import React from 'react';
import classNames from 'classnames';

interface FormProps<T> {
    formData: T;
    initialState?: T;
    onFieldChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onSave: () => void;
    onUndo?: () => void;
    formRef: React.RefObject<HTMLFormElement>;
    isLoading: boolean;
    children?: React.ReactNode;
    className?: string;
    buttonsVertical?: boolean;
    saveText?: string;
    cancelText?: string;
}

export function GenericForm<T>({
    formData,
    initialState,
    onFieldChange,
    onSave,
    onUndo,
    formRef,
    isLoading,
    children,
    className,
    buttonsVertical,
    saveText,
    cancelText,
}: FormProps<T>) {
    return (
        <form ref={formRef} onSubmit={(e) => e.preventDefault()} className={classNames(
            'flex flex-col',
            className,
        )}>
            {children}
            <div className={classNames(
              'flex',
              buttonsVertical ? 'gap-2.5 flex-col-reverse mt-10 md:mt-12' : 'gap-2 justify-end mt-4',
            )}>
                <button
                    className={classNames(
                      'btn-primary-inverted bg-transparent disabled:bg-transparent disabled:cursor-not-allowed self-start',
                      buttonsVertical ? 'w-full' : 'w-auto',
                    )}
                    onClick={onUndo}
                    disabled={(JSON.stringify(formData) === JSON.stringify(initialState)) || isLoading}
                >
                    {cancelText ? cancelText : "Undo"}
                </button>
                <button
                    className={classNames(
                      'btn-primary self-start',
                      buttonsVertical ? 'w-full' : 'w-auto min-w-36',
                    )}
                    onClick={onSave}
                    disabled={isLoading}
                >
                    {isLoading ? 'Saving...' : (saveText ? saveText : 'Save Changes')}
                </button>
            </div>
        </form>
    );
}
